export const fireGTMDownloadFileEvent = (type, filename) => {
	window.dataLayer.push({
		event: 'user_file_download',
		fileType: type,
		filename: filename
	});
}

export const returnTranslatedPaymentMethod = (paymentMethod) => {
	let paymentMethodTranslated = "";
	if(paymentMethod === "fix"){
		paymentMethodTranslated = "fixe";
	}else if(paymentMethod === "invoice"){
		paymentMethodTranslated = "facture";
	}else if(paymentMethod === "subaccount"){
		paymentMethodTranslated = "sous-compte";
	}
	return paymentMethodTranslated
}

export const fireGTMOrderingEvent = (status,extraFields) => {
	window.dataLayer.push({
		event: 'ordering_event',
		status : status,
		...extraFields
	});
}

export const fireGTMPaymentEvent = (status,extraFields) => {
	window.dataLayer.push({
		event: 'payment_event',
		status : status,
		...extraFields
	});
}

export const fireGTMWafError = (isAjax, path) => {
	window.dataLayer.push({
		event: 'waf_error',
		isAjax: isAjax,
		path: path
	});
}

export const isAgentSession = (user) => {
	let agent_session= "";
	if(!user.original_user_id && user.personnification_account_id > 0){
		agent_session = "compte";
	} else if(user.original_user_id > 0){
		agent_session = "usager";
	}
	return agent_session;
}

export const getTrackingUserId = (user) => {
	return user.original_user_id ? user.original_user_id : user.user_id;
}

export const isHarnoisOrClient = (user) => {
	if(user.can_personify){
		return "harnois-agent"
	}else if(user.is_account_owner){
		return "client-principal"
	}else{
		return "client-employe"
	}
}
